import { Component } from '@angular/core';
import { BusinessUnitGridCellActions } from '../../models/business-unit-grid-cell-actions.model';

@Component({
  standalone: false,
  selector: 'app-business-units-actions-renderer',
  templateUrl: './business-units-actions-renderer.component.html',
  styleUrls: ['./business-units-actions-renderer.component.scss'],
})
export class BusinessUnitsTableActionsRendererComponent {
  params?: BusinessUnitGridCellActions;

  // gets called once before the renderer is used
  agInit(params: BusinessUnitGridCellActions): void {
    this.params = params;
  }

  deleteClick() {
    this.params?.onDeleteClick(this.params.data.id!);
  }
}
